module.exports = __webpack_public_path__ + "img/explam.271ed636.png";